export const enum USER_ROLES {
  SUPER_ADMIN = 'SYSTEM_ADMIN',
  ORG_ADMIN = 'ORGANIZATION_ADMIN',
  EMPLOYEE = 'EMPLOYEE'
}
